import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import "@babel/polyfill"; // Needed for IE

import Vue from "vue";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import App from "./App.vue";

import "./plugins/vuelidate";
import "./plugins/vuetify";
import "./plugins/error-handler";
import AutoRequireComponents from "./plugins/auto-require-components";
import filters from "./plugins/filters";

sync(store, router);

Vue.use(AutoRequireComponents, {
  requireComponent: (require as any).context(
    "./components",
    true, // include subfolders?
    /[A-Z]\w+\.(vue|js|ts)$/
  ),
});

Vue.use(filters);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
